import { atom } from 'jotai'

export const navIndicatorAtom = atom<{
  left?: string | 0
  width?: string | 0
}>({ left: 0, width: 0 })
